import { TRADE_IN_DEVICE_STORAGE } from '@vfde-fe/sails-constants';
import { getSessionStorageItemJson } from '@vfde-fe/sails_core';
import { Device } from '../interfaces/api';

/**
 * get device from storage
 */
export const getDeviceFromStorage = (): Device | null => {
    return getSessionStorageItemJson<Device | null>(TRADE_IN_DEVICE_STORAGE);
};
